// coupon-common/src/modules/impact/duck.js
import { createActions, createReducer } from 'reduxsauce';

export const { Types, Creators } = createActions(
  {
    // Campaigns
    getImpactCampaigns:        [],
    getImpactCampaignsRequest: [],
    getImpactCampaignsSuccess: ['data'],
    getImpactCampaignsFailure: ['error'],

    // Deals
    getImpactDeals:        ['params'],
    getImpactDealsRequest: [],
    getImpactDealsSuccess: ['data'],
    getImpactDealsFailure: ['error'],

    // Catalogs (list of feeds for a campaign)
    getImpactCatalogs:        ['params'],
    getImpactCatalogsRequest: [],
    getImpactCatalogsSuccess: ['data'],
    getImpactCatalogsFailure: ['error'],

    // Catalog items (products within a single catalog)
    getImpactCatalogItems:        ['params'],
    getImpactCatalogItemsRequest: [],
    getImpactCatalogItemsSuccess: ['data'],
    getImpactCatalogItemsFailure: ['error'],
  },
  { prefix: 'cb/impact/' }
);

const INITIAL_STATE = {
  campaigns:      [],
  deals:          [],
  catalogs:       [],
  catalogItems:   [],
  catalogHasMore: false,
  catalogPage:    1,
  loading: {
    campaigns:    false,
    deals:        false,
    catalogs:     false,
    catalogItems: false,
  },
  error: {
    campaigns:    null,
    deals:        null,
    catalogs:     null,
    catalogItems: null,
  },
};

// ─── Campaigns ───────────────────────────────────────────────────────────────
const getCampaignsRequest = (state) => ({
  ...state,
  loading: { ...state.loading, campaigns: true },
  error:   { ...state.error,   campaigns: null  },
});
const getCampaignsSuccess = (state, { data }) => ({
  ...state,
  campaigns: data.campaigns || [],
  loading:   { ...state.loading, campaigns: false },
});
const getCampaignsFailure = (state, { error }) => ({
  ...state,
  loading: { ...state.loading, campaigns: false },
  error:   { ...state.error,   campaigns: error  },
});

// ─── Deals ───────────────────────────────────────────────────────────────────
const getDealsRequest = (state) => ({
  ...state,
  loading: { ...state.loading, deals: true },
  error:   { ...state.error,   deals: null },
});
const getDealsSuccess = (state, { data }) => ({
  ...state,
  deals:   data.deals || [],
  loading: { ...state.loading, deals: false },
});
const getDealsFailure = (state, { error }) => ({
  ...state,
  loading: { ...state.loading, deals: false },
  error:   { ...state.error,   deals: error  },
});

// ─── Catalogs ─────────────────────────────────────────────────────────────────
const getCatalogsRequest = (state) => ({
  ...state,
  catalogs: [],          // clear previous campaign's catalogs
  loading:  { ...state.loading, catalogs: true },
  error:    { ...state.error,   catalogs: null  },
});
const getCatalogsSuccess = (state, { data }) => ({
  ...state,
  catalogs: data.catalogs || [],
  loading:  { ...state.loading, catalogs: false },
});
const getCatalogsFailure = (state, { error }) => ({
  ...state,
  loading: { ...state.loading, catalogs: false },
  error:   { ...state.error,   catalogs: error  },
});

// ─── Catalog items ────────────────────────────────────────────────────────────
const getCatalogItemsRequest = (state) => ({
  ...state,
  loading: { ...state.loading, catalogItems: true },
  error:   { ...state.error,   catalogItems: null  },
});
const getCatalogItemsSuccess = (state, { data }) => ({
  ...state,
  // Page 1 replaces; subsequent pages append
  catalogItems:   data.page === 1
    ? (data.items || [])
    : [...state.catalogItems, ...(data.items || [])],
  catalogHasMore: data.has_more || false,
  catalogPage:    data.page || 1,
  loading:        { ...state.loading, catalogItems: false },
});
const getCatalogItemsFailure = (state, { error }) => ({
  ...state,
  loading: { ...state.loading, catalogItems: false },
  error:   { ...state.error,   catalogItems: error  },
});

export const HANDLERS = {
  [Types.GET_IMPACT_CAMPAIGNS_REQUEST]: getCampaignsRequest,
  [Types.GET_IMPACT_CAMPAIGNS_SUCCESS]: getCampaignsSuccess,
  [Types.GET_IMPACT_CAMPAIGNS_FAILURE]: getCampaignsFailure,

  [Types.GET_IMPACT_DEALS_REQUEST]: getDealsRequest,
  [Types.GET_IMPACT_DEALS_SUCCESS]: getDealsSuccess,
  [Types.GET_IMPACT_DEALS_FAILURE]: getDealsFailure,

  [Types.GET_IMPACT_CATALOGS_REQUEST]: getCatalogsRequest,
  [Types.GET_IMPACT_CATALOGS_SUCCESS]: getCatalogsSuccess,
  [Types.GET_IMPACT_CATALOGS_FAILURE]: getCatalogsFailure,

  [Types.GET_IMPACT_CATALOG_ITEMS_REQUEST]: getCatalogItemsRequest,
  [Types.GET_IMPACT_CATALOG_ITEMS_SUCCESS]: getCatalogItemsSuccess,
  [Types.GET_IMPACT_CATALOG_ITEMS_FAILURE]: getCatalogItemsFailure,
};

export default createReducer(INITIAL_STATE, HANDLERS);
export { Types as types, Creators as actions };